import React from "react";
import kn_logo from "../../../assets/kn_logo.svg";
import {Link} from "react-router-dom";

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * This functions displays the header of the WebApp
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 */
export function Header() {
  return (
    <header>
      <Link to="/">
        <img src={kn_logo} alt={"logo"} className={"logo"} />
      </Link>

      <Link to="/unsuccessfulDelivery">
        <h4>Auswirkungen nicht erfolgreicher Zustellungen</h4>
      </Link>
    </header>
  );
}
